import * as React from "react";
export default function TabPane(props) {
    return React.createElement(React.Fragment, null);
}
